<template>
  <div class="list">
    <header-bar :isIndex="true"></header-bar>
    <section class="main cl">
      <div class="main-left fl bg-white">
        <div class="news-con">
          <header>
            <h1>{{ detailData.title }}</h1>
            <div class="news-author">
              <div class="name-info-box">
                <img
                :src="detailData.userIcon || '/static/img/mr-usericon.png'"
                alt=""
                @click="userCenter(detailData.userId)"
              />
              <div class="rz-box">
                <div>
                  <span>{{ detailData.userName }}</span>
                  <img v-if="detailData.certify == 1" class="dv-rz" src="/static/img/d-v-rz.png" alt="">
                </div>
                <div v-if="detailData.certify == 1" class="dv-rz-text">大河号认证</div>
              </div>
              <el-button
                plain
                round
                size="mini"
                :class="[
                  {
                    'el-icon-check': attentionFlag == 1,
                    'el-icon-plus': attentionFlag == 0,
                  },
                  'follow-btn',
                ]"
                v-if="userToken && userInfo.id != detailData.userId"
                @click="followBtn"
              >
                {{ this.attentionFlag == 1 ? "已关注" : "关注" }}</el-button
              >
              <el-button
                plain
                round
                size="mini"
                :class="[
                  {
                    'el-icon-check': attentionFlag == 1,
                    'el-icon-plus': attentionFlag == 0,
                  },
                  'follow-btn',
                ]"
                v-else
                @click="followBtn"
              >
                关注</el-button
              >
              </div>
              <!-- <el-button plain round size="mini" class="el-icon-message"> 私信</el-button> -->
              <img v-if="detailData.adopt == 1" class="adoptIcon" src="../assets/images/adopt-icon.png" alt="">
            </div>
            <p class="cl">
              <span class="mr20">
                <i class="el-icon-pubtime"></i>{{ detailData.createTime }}
              </span>
              <span class="mr20">
                <i class="el-icon-look"></i>{{ detailData.pvStr }}
              </span>
            </p>
            <h3 class="news-topic" v-if="detailData.topicName">
              <a :href="'/topic/' + detailData.topicId" target="_blank">{{
                detailData.topicName
              }}</a>
            </h3>
          </header>
          <div class="news-info" v-if="detailData.videoUrl">
            <iframe
              width="100%"
              height="400"
              :src="
                'https://player.dahe.cn/dh_player/?videosrc=' +
                detailData.videoUrl
              "
              frameborder="0"
              allowfullscreen
            >
            </iframe>
          </div>
          <div class="news-info" v-else v-html="detailData.content"></div>
          <div class="vote" v-if="detailData.voteFlag && detailData.voteFlag !== 0">
            <div class="topicTitle">
              {{ voteTheme.name }}
            </div>
            <div :class="classObject" v-for="(option, index) in voteOptions" :key="index" :style="styleObject" @click="voted(option.id, option.ifVote,detailData.id, 1)">
          <span class="voteText">{{ option.name }}&nbsp;<img class="voted-logo" src="../assets/images/votedLogo.png" alt=""
                                                             v-show="option.ifVote"></span>
              <span :class="{optionBg: optionBg ,o: true}"></span><span class="voteNum" v-show="voteNum">{{option.numStr}}人</span></div>
            <p class="voteInfo">{{ userNumStr }}&emsp;{{formatEndTime }}</p>
          </div>
          <div class="state-box">
            声明：该内容仅代表作者，大河号系信息发布平台，如有侵权，请联系400-6371669，进行删除。
          </div>
          <div class="report-box">
            <span class="report" @click="dialogVisible2 = true">举报</span>
          </div>
          <div class="discuss-box">
            <div class="discuss-num">
              共<span>{{ detailData.discussStr }}</span
              >条评论
            </div>
            <div class="set-discuss">
              <img
                v-if="userToken"
                class="user-icon"
                :src="
                  userInfo.icon
                    ? userInfo.icon
                    : '../../static/img/mr-usericon.png'
                "
                alt=""
              />
              <img
                v-else
                class="user-icon"
                src="../../static/img/mr-usericon.png"
                alt=""
              />
              <div class="textarea-box">
                <!-- <div class="pic-icon">
                  <el-popover
                    placement="top-start"
                    trigger="click"
                    popper-class="emoBox"
                  >
                    <div class="emotionList">
                      <a
                        href="javascript:void(0);"
                        class="emotionItem"
                        v-for="(item, index) in faceList"
                        :key="index"
                        @click="getEmo(index)"
                        >{{ item }}</a
                      >
                    </div>
                    <el-button class="emotionSelect" slot="reference">
                      <img src="../assets/images/icon/set-icon.png" alt="" />
                    </el-button>
                  </el-popover>
                </div> -->
                <div v-if="userToken" class="textarea">
                  <!-- <el-input
                    type="textarea"
                    placeholder="发布你的看法"
                    v-model="textarea"
                    id="textarea"
                    maxlength="200"
                    resize="none"
                  >
                  </el-input> -->
                  <!-- <vue-ueditor-wrap
                    v-model="textarea"
                    :config="myConfig"
                  ></vue-ueditor-wrap> -->
                  <editor-bar v-model="textarea" :menus="menus" :height="150" @change="change"></editor-bar>
                </div>
                <el-button
                  v-if="userToken"
                  class="discuss-btn"
                  @click="discussBtn"
                  >评论</el-button
                >
                <div v-else class="no-login">
                  请先<span @click="loginTo">登录</span>后发表评论
                </div>
              </div>
            </div>
            <div class="discuss-list">
              <discuss-list
                v-for="(item, i) in discussDataList"
                :key="i"
                :dataList="item"
                :index="i"
              ></discuss-list>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="main-right fr">
        <com-foot></com-foot>
      </div>
      <div class="like-left-box">
        <div class="like-list" @click="likeBtn">
          <img
            :src="
              detailData.likeFlag == 0
                ? '/static/img/like-icon.png'
                : '/static/img/like-icon-on.png'
            "
            alt=""
          />
          <p>{{ detailData.likeStr }}</p>
        </div>
        <div class="like-list" @click="collectBtn">
          <img
            :src="
              detailData.collectFlag == 0
                ? '/static/img/sc-icon.png'
                : '/static/img/sc-icon-on.png'
            "
            alt=""
          />
          <p>{{ detailData.collectStr }}</p>
        </div>
        <!-- <div class="like-list">
          <img src="/static/img/share-icon.png" alt="" />
        </div> -->
        <el-popover hidden placement="left" width="60px" trigger="hover">
          <div class="share-box">
            <img src="/static/img/wx-icon.png" alt="" />微信
          </div>
          <div class="share-box">
            <img src="/static/img/wb-icon.png" alt="" />新浪微博
          </div>
          <el-button class="like-list" slot="reference"
            ><img src="/static/img/share-icon.png" alt=""
          /></el-button>
        </el-popover>
      </div>
    </section>
    <el-dialog
      title="活动报名"
      :visible.sync="dialogVisible"
      width="514px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="login-success">
        <div class="login-input">
          <el-form ref="form" :rules="rules" :model="form" label-width="60px">
            <el-form-item label="姓名" prop="name">
              <el-input placeholder="请输入姓名" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <div class="phone-numbox">
                <el-input
                  placeholder="请输入手机号"
                  v-model.trim="form.phone"
                  clearable
                >
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="性别" prop="sex">
              <el-radio-group v-model="form.sex">
                <el-radio :label="1">男</el-radio>
                <el-radio :label="0">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="留言" prop="textarea">
              <el-input
                type="textarea"
                maxlength="30"
                show-word-limit
                placeholder="留言"
                v-model="form.note"
                resize="none"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="login-next">
          <el-button type="danger" round @click="onSubmit">确定</el-button>
          <el-button type="danger" @click="dialogVisible = false" round
            >取消</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="举报"
      :visible.sync="dialogVisible2"
      width="402px"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="login-success">
        <div class="login-report">
          <div class="report-title">请选择举报理由</div>
          <el-radio-group v-model="reportRadio">
            <el-radio label="0">欺诈</el-radio>
            <el-radio label="1">色情</el-radio>
            <el-radio label="2">诱导行为</el-radio>
            <el-radio label="3">不实信息</el-radio>
            <el-radio label="4">违法犯罪</el-radio>
            <el-radio label="5">骚扰</el-radio>
            <el-radio label="7">新冠肺炎疫情相关</el-radio>
            <el-radio label="6">其它</el-radio>
          </el-radio-group>
        </div>
        <div class="login-next">
          <el-button type="danger" round @click="reportSubmit">举报</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible3"
      width="340px"
      :modal-append-to-body="false"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class="rewardDialog"
      v-if="userToken"
    >
      <img :src="detailData.userIcon" alt="" />
      <div class="reward-username">{{ detailData.userName }}</div>
      <div class="talk-thanks">{{ rewardRadioText }}</div>
      <div class="reward-radio">
        <el-radio-group v-model="rewardRadio" @change="rewardRadioBtn">
          <el-radio-button
            v-for="(item, index) in rewardRadioLabel"
            :label="item.label"
            :key="index"
            :name="item.thanksText"
          ></el-radio-button>
        </el-radio-group>
      </div>
      <div class="reward-btn-box">
        <el-button
          v-if="userInfo.coin >= rewardRadio"
          type="primary"
          round
          :loading="rewardBtnLoading"
          @click="rewardBtn(detailData.id)"
          >打赏{{ rewardRadio }}个眼遇币</el-button
        >
        <el-button v-else type="primary" disabled round
          >眼遇币余额不足</el-button
        >
      </div>
      <div class="residue-coin">剩余眼遇币：{{ userInfo.coin }}个</div>
    </el-dialog>
    <back-top></back-top>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import store from "@/store";
import HeaderBar from "@/components/Header.vue";
import DiscussList from "@/components/DiscussList.vue";
import emoji from "emoji.json";
import BackTop from "@/components/BackTop.vue";
import ComFoot from "@/components/ComFoot.vue";
import EditorBar from '@/components/Editor.vue';
export default {
  name: "Detail",
  components: {
    HeaderBar,
    DiscussList,
    BackTop,
    ComFoot,
    EditorBar,
  },
  data() {
    let checkPhone = function (rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      voteTheme: '',
      voteOptions: [],
      styleObject: {
        textAlign: 'center'
      },
      classObject: {
        options: true,
        moveLeft: false
      },
      optionBg: false,
      optionBgWidth: [],
      voteNum: false,
      userNumStr: '',
      formatEndTime :'',
      timeStatus: 0,
      userToken: store.state.UserToken
        ? store.state.UserToken
        : localStorage.getItem("UserToken"),
      userInfo: store.state.UserInfo
        ? store.state.UserInfo
        : JSON.parse(localStorage.getItem("UserInfo")),
      newsId: this.$route.params.id,
      targetType: this.$route.params.targetType,
      detailData: {},
      articleHotDataList: [],
      total: 0,
      textarea: "",
      channelInfo: {},
      userId: "",
      attentionFlag: "",
      urlSwitch: "",
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      reportRadio: "",
      rules: {
        phone: [
          {
            required: true,
            validator: checkPhone,
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        sex: [
          {
            required: true,
            message: "请选择性别",
            trigger: "blur",
          },
        ],
      },
      menus:[
        "foreColor", // 文字颜色
        "backColor", // 背景颜色
        "image", // 插入图片
      ],
      // myConfig: {
      //   UEDITOR_HOME_URL: "/static/ue/",
      //   initialFrameHeight: 200,
      //   autoFloatEnabled: false,
      //   zIndex: 0,
      //   toolbars: [
      //     [
      //       // 'emotion',
      //       "insertimage",
      //       "forecolor",
      //       "autotypeset",
      //     ],
      //   ],
      // },
      form: {
        activityId: "",
        phone: "",
        name: "",
        sex: 1,
        note: "",
      },
      current: 1,
      size: 10,
      discussDataList: [],
      faceList: [],
      rewardDataList: [],
      rewardNum: "",
      rewardRadio: 1,
      rewardRadioText: "一个也是爱",
      rewardRadioLabel: [
        {
          label: 1,
          thanksText: "一个也是爱",
        },
        {
          label: 10,
          thanksText: "nèng嘞不赖",
        },
        {
          label: 30,
          thanksText: "还想再看",
        },
        {
          label: 50,
          thanksText: "这文章中嘞很",
        },
        {
          label: 100,
          thanksText: "大神请笑纳",
        },
        {
          label: 200,
          thanksText: "爱了爱了，都给你",
        },
      ],
      rewardBtnLoading: false,
    };
  },
  mounted() {
    for (let i in emoji) {
      this.faceList.push(emoji[i].char);
    }
  },
  methods: {
    ...mapActions(["LOGIN", "GET_USERINFO"]),
    // 请求用户信息
    rewardRadioBtn() {
      for (var i = 0; i < this.rewardRadioLabel.length; i++) {
        if (this.rewardRadio == this.rewardRadioLabel[i].label) {
          this.rewardRadioText = this.rewardRadioLabel[i].thanksText;
        }
      }
    },
    getUserInfo() {
      this.GET_USERINFO()
        .then(() => {
          this.userInfo = JSON.parse(localStorage.getItem("UserInfo"));
        })
        .catch(() => {});
    },
    showRewardDialog(id) {
      if (this.userToken) {
        if (id == this.userInfo.id) {
          this.$message.warning("不可对自己操作，请对他人的文章进行打赏哦~");
        } else {
          this.dialogVisible3 = true;
        }
      } else {
        this.$message.warning("请登录后查看");
      }
    },
    // 投票
    clickOptions (ifVote,check) {
      this.classObject.moveLeft = true;
      let voteText = document.getElementsByClassName('voteText');
      let len = document.getElementsByClassName('o');
      let voteSum = 0;
      let voteOptions = document.getElementsByClassName('options');
      for (let i = 0; i < voteText.length; i++) {
        voteText[i].style.margin = '0';
      }
      for (let i = 0; i < len.length; i++) {
        voteSum += this.voteOptions[i].num;
      }
      for (let i = 0; i < len.length; i++) {
        len[i].style.width = 0;
      }
      for (let i = 0; i < len.length; i++) {
        this.optionBgWidth[i] = (this.voteOptions[i].num/voteSum).toFixed(2) * 100;
        len[i].style.width = this.optionBgWidth[i] + '%';
        // len[i].classList.add('optionBg');
        if (check === 1 || ifVote === 1){
          // len[i].classList.remove('optionBg');
          // len[i].classList.add('optionBg2');
          this.optionBg = true;
        }
      }
      if (this.timeStatus === 2) {
        for (let i = 0; i < voteOptions.length; i++) {
          voteOptions[i].addEventListener('mouseover', function () {
            voteOptions[i].style.cursor = 'default';
            voteOptions[i].style.border = '1px solid #DADADA';
          })
        }
      }
      this.voteNum = true;
      this.optionBg = !this.optionBg;
    },
    voted(id, ifVote,infoId, check) {
      var obj = {
        id: infoId,
      };
      if (ifVote === 1 || this.timeStatus === 0 || this.timeStatus === 2) return false;
      if (this.userToken === null || this.userToken === '') {
        this.$message.warning("请登录后查看");
        return false;
      }

      this.clickOptions(ifVote, check);
      this.$api
        .voteHandlePC({
          optionIds: id,
          targetId: this.newsId,
          themeId: this.voteTheme.id,
          userId: this.userId,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.getDetailData();
          }
        });
    },
    //打赏
    rewardBtn(id) {
      this.rewardBtnLoading = true;
      this.$api
        .articleDonate({
          articleId: id,
          coin: this.rewardRadio,
        })
        .then((res) => {
          let _this = this;
          this.$message({
            message: "打赏成功",
            type: "success",
            duration: 2000,
            onClose: function () {
              _this.rewardData();
            },
          });
          this.dialogVisible3 = false;
          this.userInfo.coin = res.data.data;
          this.rewardBtnLoading = false;
        });
    },
    //打赏列表
    rewardData() {
      this.$api
        .donateList({
          id: this.newsId,
        })
        .then((res) => {
          this.rewardNum = res.data.data.count;
          this.rewardDataList = res.data.data.list;
        });
    },
    //立即报名
    signUp() {
      if (this.userToken) {
        this.dialogVisible = true;
      } else {
        let _this = this;
        this.$message({
          message: "请登录后查看",
          type: "warning",
          duration: 2000,
          onClose: function () {
            _this.$router.push("/login");
          },
        });
      }
    },
    //插入表情
    getEmo(index) {
      var textArea = document.getElementById("textarea");
      function changeSelectedText(obj, str) {
        str = str + " ";
        if (window.getSelection) {
          // 非IE浏览器
          textArea.setRangeText(str);
          // 在未选中文本的情况下，重新设置光标位置
          textArea.selectionStart += str.length;
          textArea.focus();
        } else if (document.selection) {
          // IE浏览器
          obj.focus();
          var sel = document.selection.createRange();
          sel.text = str;
        }
      }
      changeSelectedText(textArea, this.faceList[index]);
      this.textarea = textArea.value;
      return;
    },
    likeBtn() {
      this.$api
        .likeHandle({
          targetType: this.targetType,
          targetId: this.newsId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.detailData.likeFlag = this.detailData.likeFlag == 1 ? 0 : 1;
          this.detailData.likeNum =
            this.detailData.likeFlag == 1
              ? this.detailData.likeNum + 1
              : this.detailData.likeNum - 1;
        });
    },
    collectBtn() {
      this.$api
        .collectHandle({
          targetType: this.targetType,
          targetId: this.newsId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.detailData.collectFlag =
            this.detailData.collectFlag == 1 ? 0 : 1;
          this.detailData.collectNum =
            this.detailData.collectFlag == 1
              ? this.detailData.collectNum + 1
              : this.detailData.collectNum - 1;
        });
    },
    reportSubmit() {
      if (!this.reportRadio) {
        this.$message.error("请选择举报理由");
        return false;
      }
      this.$api
        .reportAdd({
          type: this.reportRadio,
          targetType: this.targetType,
          targetId: this.newsId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.dialogVisible2 = false;
          this.reportRadio = "";
        });
    },
    discussBtn() {
      if (!this.textarea) {
        this.$message.error("请输入评论");
        return false;
      }
      this.$api
        .discussAdd({
          content: this.textarea,
          pid: 0,
          targetType: this.targetType,
          targetId: this.newsId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.textarea = "";
        });
    },
    getDiscussData() {
      this.$api
        .discussList({
          current: this.current,
          size: this.size,
          type: this.targetType,
          id: this.newsId,
        })
        .then((res) => {
          this.total = res.data.data.total;
          this.discussDataList = res.data.data.records;
        });
    },
    handleSizeChange(e) {
      this.size = e;
      this.getDiscussData();
    },
    handleCurrentChange(e) {
      this.current = e;
      this.getDiscussData();
    },
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.activityEnroll(this.form).then((res) => {
            this.$message.success(res.data.msg);
            this.dialogVisible = false;
            this.resetForm("form");
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.form.note = "";
    },
    followBtn() {
      this.$api
        .attentionHandle({
          userId: this.userId,
        })
        .then((res) => {
          this.$message.success(res.data.msg);
          this.attentionFlag = this.attentionFlag == 1 ? 0 : 1;
        });
    },
    getDetailData() {
      this.busy = true;
      this.urlSwitch =
        this.targetType == 0 ? "articleDetail" : "activityDetail";
      this.$api[this.urlSwitch]({
        id: this.newsId,
      }).then((res) => {
        this.detailData = res.data.data;
        this.getyfxFun(this.detailData.id,this.detailData.title,this.detailData.createTime)
        this.userId = res.data.data.userId;
        this.attentionFlag = res.data.data.attentionFlag;
        this.form.activityId = res.data.data.id;
        this.getChannelDetail();
        this.wxshare(res.data.data.title, res.data.data.summary);
        this.getDiscussData();
        this.voteOptions = res.data.data.voteOptions;
        if(res.data.data.voteTheme){
          this.voteTheme = res.data.data.voteTheme;
          this.userNumStr = res.data.data.voteTheme.userNumStr + '人参与';
          this.formatEndTime ='还有' + res.data.data.voteTheme.formatEndTime + '结束';
          this.timeStatus = res.data.data.voteTheme.timeStatus;
        }
        document.title = res.data.data.title + "-大河号-大河网";
        setTimeout(() => {
          if (res.data.data.voteFlag === 2) {
            this.clickOptions();
          }
          if (this.timeStatus === 2) {
            if (res.data.data.voteFlag === 1) this.clickOptions();
            let bgGray = document.getElementsByClassName('o');
            let voteText = document.getElementsByClassName('voteText');
            let voteNum = document.getElementsByClassName('voteNum');
            let votedLogo = document.getElementsByClassName('voted-logo');
            this.formatEndTime = '投票已结束';
            for (let i = 0; i < bgGray.length; i++) {
              bgGray[i].style.background = '#efefef';
              voteText[i].style.color = '#aaa';
              voteNum[i].style.color = '#aaa';
              votedLogo[i].classList.add('img-bg-gray');
            }
          } else if (this.timeStatus === 0) {
            this.userNumStr = '';
            this.formatEndTime = '投票将在 ' + res.data.data.voteTheme.beginTime + ' 开始';
          }
        }, 500);
      });
    },
    getyfxFun(id,title,time) {
      function formatDateToTimestamp(dateStr) {
          const date = new Date(dateStr);
          return date.getTime();
      }
      window._dhjs_self_appConfig = {
          /* 通用必填项 */
          appKey:'bec8e65467f44f86ba7d1ff2207aea18',
          isAPP:window.navigator.userAgent.includes('yydh_')?1:0,/* 1：客户端内访问 0：客户端外访问 必填  需自行各加结合app端头部自行区分window.navigator.userAgent.includes */
          /* 新闻详情页必填项 */
          newsID:id,//- 新闻id  必填
          newsTitle:title,//- 新闻标题 必填
          newsUrl:window.location.href,//- 新闻链接 必填
          pubTime:formatDateToTimestamp(time),//- 发布时间 时间戳（） 13位 必填
          /* 选填项 */
          pubChannel:'',//- 所属栏目
          newsSource:'',//- 新闻来源
          newsCompany:'',//- 新闻发布单位 依据数组中的名称填写 注:错误无效 ['河南日报社','大河网','顶端新闻','大河报','河南商报','河南法制报','期货日报','大河健康报','大河美术报','大河财立方','河南手机报','今日消费','河南日报农村版']
          newsLikeNum:'',//- 新闻点赞量 number/string
          newsCommentNum:'',//- 新闻评论量 number/string
          newsTransmitNum:'',//- 新闻转发量number/string
          newsCollect:'',//- 新闻收藏量number/string
          newsCommentContent:[],//- 新闻评论内容
      };
      (function () {
          var ma = document.createElement('script');
          ma.type = 'text/javascript';
          ma.async = true;
          ma.src = "https://uploads.dahe.cn/xrf/dhfx/index-dn.min.js";
          document.body.appendChild(ma);
      })();
    },
    getChannelDetail() {
      this.$api
        .channelDetail({
          id: this.detailData.channelId,
        })
        .then((res) => {
          this.channelInfo = res.data.data;
        });
    },
    toList(i, n) {
      this.$router.push("/list/" + i + "/" + n);
    },
    loginTo() {
      this.$router.push("/login?url=" + window.location.pathname);
    },
    wxshare(t, d) {
      let sharelink = window.location.href;
      let sharetitle = t;
      let shareimgUrl = "https://bbs.dahe.cn/static/sharelogo.jpg";
      let sharedes = d;

      let result = fetch(
        "https://share.dahe.cn/share/yanyu?url=" + encodeURIComponent(sharelink)
      );
      result
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          let text = data.object;

          /* 微信 */
          wx.config({
            debug: false, // 开启调试模式。
            appId: text.appId, // 必填，公众号的唯一标识
            timestamp: text.timestamp, // 必填，生成签名的时间戳
            nonceStr: text.nonceStr, // 必填，生成签名的随机串
            signature: text.signature, // 必填，签名
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 必填，需要使用的JS接口列表
          });

          wx.checkJsApi({
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              // console.log(res)
            },
          });

          //需在用户可能点击分享按钮前就先调用
          wx.ready(function () {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              desc: sharedes, // 分享描述
              success: function () {
                // 设置成功
              },
            });

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
              title: sharetitle, // 分享标题
              link: sharelink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareimgUrl, // 分享图标
              success: function () {
                // 设置成功
              },
            });
          });

          wx.error(function (res) {
            console.log("err: " + res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        })
        .catch(function (ex) {
          console.log("failed", ex);
        });
    },
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
    change(val) {
      this.textarea = val
    }
  },
  created() {
    this.getDetailData();
    this.rewardData();
    if (this.userToken) {
      this.getUserInfo();
    }
  },
  watch: {
    $route(to, from) {
      (this.newsId = this.$route.params.id), this.getDetailData();
    },
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 0 auto 10px;
  padding-top: 70px;
  .main-left {
    width: 680px;
    .news-con {
      header {
        padding: 30px 24px 24px;
        border-bottom: 1px solid #efefef;
        h1 {
          font-size: 26px;
          font-weight: bold;
        }
        .news-author {
          margin: 11px 0;
          display: flex;
          justify-content: space-between;
          .name-info-box {
            display: flex;
            align-items: center;
          }
          img {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            vertical-align: middle;
            margin-right: 5px;
            cursor: pointer;
          }
          // span {
          //   margin-right: 17px;
          // }
          .rz-box {
            display: flex;
            flex-direction:column;
            .dv-rz-text {
              font-size: 14px;
              color: #999999;
            }
          }
          .dv-rz {
            width: 16px;
            height: 16px;
          }
          .follow-btn {
            // width: 97px;
            height: 30px;
            background: #ffffff;
            border-radius: 17px;
            color: #317dff;
            border: 1px solid #317dff;
            font-size: 16px;
            margin-left: 20px;
          }
          .adoptIcon {
            width: 133px;
            height: 106px;
            border-radius: 0;
          }
        }
        p {
          height: 16px;
          color: #999999;
          span {
            display: flex;
            align-items: center;
            float: left;
            font-size: 13px;
          }
          i {
            margin-right: 6px;
            display: inline-block;
            width: 15px;
            height: 16px;
            &.el-icon-pubtime {
              width: 16px;
              background: url("../assets/images/icon/pubtime.png") center
                no-repeat;
            }
            &.el-icon-look {
              width: 18px;
              background: url("../assets/images/icon/look.png") center no-repeat;
            }
          }
        }
        .news-topic {
          font-size: 14px;
          font-weight: 400;
          margin-top: 10px;
          line-height: 26px;
          a {
            color: #317dff;
          }
        }
      }
      .active-info {
        width: 632px;
        height: 129px;
        background: #f7f7f7;
        border-left: 5px solid #317dff;
        margin: 16px auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .activeInfo-box {
          font-size: 15px;
          color: #666666;
          line-height: 27px;
          padding: 10px;
        }
        .sign-up {
          height: 40px;
          padding: 0 33px;
          background: #317dff;
          border-radius: 20px;
          line-height: 40px;
          margin-right: 40px;
          font-size: 15px;
          color: #ffffff;
          cursor: pointer;
        }
        .sign-up-end {
          height: 40px;
          padding: 0 33px;
          background: #ebebeb;
          border-radius: 20px;
          line-height: 40px;
          margin-right: 40px;
          font-size: 15px;
          color: #4c4c4c;
          cursor: pointer;
        }
      }
      .news-info {
        // padding: 19px 24px;
        line-height: 1.8;
        font-size: 15px;
        line-height: 26px;
        color: #121212;
        text-align: justify;
        border-bottom: 1px dashed #efefef;
        width: 632px;
        margin: 19px 24px;
        /deep/ p {
          margin-bottom: 10px;
        }
        /deep/ img {
          max-width: 100%;
          display: block;
          height: auto;
          margin: 0 auto;
        }
        /deep/ iframe {
          width: 100%;
          display: block;
        }
      }
      .vote {
        width: 632px;
        margin: 0 auto;
        background: #f6f6f6;
        padding: 15px;
        .topicTitle {
          margin-bottom: 15px;
          font-size: 17px;
        }
        .options {
          background: #fff;
          border: 1px solid #DADADA;
          height: 32px;
          line-height: 32px;
          margin-bottom: 10px;
          color: #317DFF;
          position: relative;
          border-radius: 4px;
          overflow: hidden;
          cursor: default;
        }
        .options:hover {
          cursor: pointer;
          border: 1px solid #357ffb;
        }

        .moveLeft {
          text-indent: 6px !important;
          text-align: left !important;
          color: #317DFF;
        }

        .optionBg {
          background-color: #E5EFFE;
          display: block;
          height: 32px;
          animation: optionBg 1.5s forwards;
          position: absolute;
          top: 0;
          width: 0;
        }
        .optionBg2 {
          background-color: #E5EFFE;
          display: block;
          height: 38px;
          animation: optionBg2 1s forwards;
          position: absolute;
          top: 0;
          width: 0;
        }
        @keyframes optionBg {
          0% {
            width: 0;
          }
        }
        @keyframes optionBg2 {
          0% {
            width: 0;
          }
        }
        .voteInfo {
          color: #999;
          font-size: 13px;
          text-align: center;
        }

        .voteNum {
          position: absolute;
          right: 6px;
          top: 0;
          font-size: 14px;
        }

        .voteText {
          display: block;
          position: relative;
          z-index: 2;
          height: 30px;
          font-size: 14px;
          margin: 0 auto;
          overflow: hidden;
          white-space: break-spaces;
        }
        .img-bg-gray {
          //-webkit-filter: grayscale(100%);
          //-moz-filter: grayscale(100%);
          //-ms-filter: grayscale(100%);
          //-o-filter: grayscale(100%);
          filter: grayscale(100%);
          //filter: url(/img/2013people/gray.svg#grayscale);
          //filter: gray;
          -webkit-filter: grayscale(1);
        }
      }
      .state-box {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 21px;
        padding: 0 24px;
      }
      .reward {
        width: 100%;
        display: flex;
        align-items: center;
        .reward-btn {
          width: 156px;
          height: 42px;
          background: #317dff;
          border-radius: 21px;
          text-align: center;
          // line-height: 42px;
          color: #fff;
          font-size: 16px;
          font-weight: 500;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          img {
            width: 16px;
            height: 20px;
            margin-right: 10px;
          }
        }
      }
      .reward-list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 12px;
        img {
          width: 34px;
          height: 34px;
          margin-right: 2px;
          border-radius: 17px;
          border: 1px solid #ECECEC;
        }
      }
      .reward-num {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        line-height: 20px;
        margin-top: 12px;
        text-align: center;
      }
      .report-box {
        width: 100%;
        text-align: right;
        padding: 10px 24px;
        .report {
          color: #666666;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          background: url("../assets/images/report-icon.png") no-repeat left
            center;
          padding-left: 20px;
          cursor: pointer;
        }
      }

      .discuss-box {
        width: 100%;
        padding: 0 30px 30px;
        .discuss-num {
          width: 100%;
          color: #121212;
          font-size: 18px;
          // border-bottom: 1px solid #efefef;
          line-height: 40px;
        }
        .set-discuss {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 20px;
          .user-icon {
            width: 32px;
            height: 32px;
            border-radius: 50%;
          }
          .textarea-box {
            width: 581px;
            min-height: 123px;
            // background: #f7f7f7;
            // border-radius: 4px;
            // border: 1px solid #eeeeee;
            .pic-icon {
              width: 100%;
              height: 28px;
              line-height: 28px;
              border-bottom: 1px solid #efefef;
              img {
                width: 12px;
                height: 12px;
                cursor: pointer;
              }
              button {
                padding: 6px 10px;
                background: none;
                border: none;
              }
            }
            .no-login {
              width: 100%;
              height: 94px;
              line-height: 94px;
              text-align: center;
              color: #121212;
              font-size: 15px;
              background: #f7f7f7;
              border-radius: 4px;
              border: 1px solid #eeeeee;
              span {
                cursor: pointer;
                color: #317dff;
              }
            }
            .textarea {
              width: 100%;
              /deep/ .el-textarea__inner {
                border: none !important;
                background: #f7f7f7 !important;
              }
            }
            .discuss-btn {
              width: 64px;
              height: 32px;
              text-align: center;
              line-height: 32px;
              color: #ffffff;
              background: #317dff;
              border-radius: 4px;
              float: right;
              font-size: 15px;
              // margin-right: 10px;
              padding: 0;
            }
          }
        }
        .discuss-list {
          width: 100%;
          margin-top: 10px;
          .el-pagination {
            margin-top: 15px;
          }
        }
      }
    }
  }
  .main-right {
    width: 310px;
    .hot-post-top10 {
      color: #121212;
      .post-title {
        font-size: 18px;
        font-weight: 600;
        padding: 18px 11px 18px 40px;
        background: url("../assets/images/icon/hot.png") center left 10px
          no-repeat;
        border-bottom: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 14px;
          font-weight: 400;
          color: #8c8c8c;
          cursor: pointer;
        }
      }
    }
    .channel-info {
      width: 310px;
      height: 206px;
      background: url("../assets/images/channel-img.png") no-repeat center
        center;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 10px;
      cursor: pointer;
      .channel-icon {
        text-align: center;
        img {
          width: 140px;
          height: 140px;
          margin-top: 18px;
        }
        p {
          font-size: 20px;
          font-weight: 600;
          color: #121212;
          line-height: 26px;
          margin-top: -42px;
        }
      }
      .info-count {
        color: #333333;
        margin-top: 20px;
        span {
          padding-left: 20px;
          &:before {
            color: #b9b9b9;
            font-size: 17px;
            margin-right: 5px;
          }
          b {
            font-size: 18px;
            margin-left: 10px;
            color: #121212;
          }
        }
        .artic-num-icon {
          background: url("../assets/images/activity-num-icon.png") no-repeat
            left center;
          font-size: 15px;
        }
        .active-num-icon {
          background: url("../assets/images/artic-num-icon.png") no-repeat left
            center;
          font-size: 15px;
        }
      }
    }
  }
  .like-left-box {
    width: 40px;
    position: fixed;
    margin-left: -65px;
    top: 132px;
    .like-list {
      width: 100%;
      cursor: pointer;
      margin-bottom: 10px;
      padding: 0;
      border: none;
      border-radius: 50%;
      img {
        width: 40px;
        height: 40px;
      }
      p {
        width: 100%;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
      }
    }
  }
}
/deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 4px;
  .el-dialog__header {
    border-bottom: 1px solid #efefef;
    .el-dialog__title {
      font-size: 17px;
      font-weight: 600;
      color: #121212;
    }
  }
  .el-dialog__body {
    padding: 0;
    .login-success {
      width: 100%;
      padding: 22px 40px 50px;
      display: flex;
      align-items: center;
      flex-direction: column;
      .login-input {
        width: 100%;
        .el-form-item__content {
          margin-left: 40px;
          .el-input {
            height: 46px;
            .el-input__inner {
              height: 46px;
              border-radius: 3px;
              background: #ffffff;
            }
            .el-input__suffix {
              height: 100%;
            }
          }
          .el-textarea {
            height: 70px;
            .el-textarea__inner {
              height: 70px;
            }
            .el-input__count {
              line-height: normal;
            }
          }
          .el-radio__inner {
            width: 16px;
            height: 16px;
          }
          .el-radio__input.is-checked .el-radio__inner {
            background: #317dff;
            color: #317dff;
            border-color: #317dff;
          }
          .el-radio__inner:hover {
            border-color: #317dff;
          }
          .el-radio__label {
            font-size: 16px;
          }
          .el-radio__input.is-checked + .el-radio__label {
            color: #121212;
          }
        }
      }
      .login-report {
        width: 100%;
        .report-title {
          width: 100%;
          font-size: 15px;
          font-weight: 400;
          color: #666666;
          text-align: center;
        }
        .el-radio-group {
          width: 100%;
          margin-top: 10px;
          .el-radio {
            width: 100%;
            padding: 12px 0;
            border-bottom: 1px solid #efefef;
            zoom: 1;
            .el-radio__input {
              float: right;
            }
            .el-radio__label {
              float: left;
            }
            .el-radio__inner {
              width: 16px;
              height: 16px;
            }
            .el-radio__input.is-checked .el-radio__inner {
              background: #317dff;
              color: #317dff;
              border-color: #317dff;
            }
            .el-radio__inner:hover {
              border-color: #317dff;
            }
            .el-radio__label {
              font-size: 16px;
              color: #121212;
            }
            .el-radio__input.is-checked + .el-radio__label {
              color: #121212;
            }
          }
        }
      }

      .login-next {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-around;
        .el-button {
          width: 128px;
          height: 40px;
          background: #317dff;
          border-radius: 4px;
          font-size: 15px;
          color: #ffffff;
        }
        .el-button:nth-child(2) {
          background: #dddddd;
          border-radius: 4px;
          border: 1px solid #dddddd;
          color: #2f2f2f;
        }
      }
    }
  }
}
/deep/ .rewardDialog {
  width: 340px;
  height: 383px;
  background: url("../assets/images/donaDialog.png") no-repeat center center;
  box-shadow: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  .el-dialog__header {
    border: none;
    // display: none;
    .el-dialog__headerbtn {
      margin-top: 40px;
      font-size: 26px;
    }
    .el-dialog__title {
      display: none;
    }
  }
  .el-dialog__body {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: -24px;
    img {
      width: 82px;
      height: 82px;
      border-radius: 50%;
    }
    .reward-username {
      font-size: 16px;
      font-weight: 600;
      color: #121212;
      line-height: 22px;
      margin-top: 12px;
    }
    .talk-thanks {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
      margin-top: 5px;
    }
    .reward-radio {
      width: 100%;
      padding: 26px 39px 14px;
      .el-radio-group {
        width: 100%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-radio-button__inner {
          padding: 0;
          width: 78px;
          height: 36px;
          line-height: 36px;
          text-align: center;
          // margin-right: 10px;
          margin-bottom: 10px;
          background: #f7f7f7;
          border-radius: 3px;
          border: 1px solid #edeff0;
          color: #666666;
          box-shadow: none;
        }
        .el-radio-button.is-active .el-radio-button__inner {
          background: #e7eeff;
          border-color: #317dff;
          color: #317dff;
        }
        .el-radio-button__inner:hover {
          color: #666666;
        }
      }
    }
    .reward-btn-box {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .el-button.is-round {
        width: 262px;
        height: 42px;
        background: #317dff;
      }
      .el-button.is-disabled {
        background: #a0cfff;
      }
    }
    .residue-coin {
      width: 100%;
      text-align: center;
      font-size: 13px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      margin-top: 11px;
    }
  }
}
// /deep/ .el-popover {
// .share-box {
//       font-size: 14px;
// font-weight: 400;
// color: #333333;
//     }
//     }
</style>
<style>
.emoBox {
  min-width: 100px;
  left: 265px;
  width: 400px;
  height: 200px;
  overflow: scroll;
}

.share-box {
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  cursor: pointer;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.share-box img {
  width: 18px;
  height: 15px;
  margin-right: 10px;
}

.emotionList {
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
}
.emotionItem {
  width: 10%;
  font-size: 20px;
  text-align: center;
}
/*包含以下四种的链接*/
.emotionItem {
  text-decoration: none;
}
/*正常的未被访问过的链接*/
.emotionItem:link {
  text-decoration: none;
}
/*已经访问过的链接*/
.emotionItem:visited {
  text-decoration: none;
}
/*鼠标划过(停留)的链接*/
.emotionItem:hover {
  text-decoration: none;
}
/* 正在点击的链接*/
.emotionItem:active {
  text-decoration: none;
}
/* 投票 */

</style>



// WEBPACK FOOTER //
// src/views/Detail.vue